import React,{useState} from "react";
import {FormattedMessage} from "react-intl";
import {get} from "lodash";
import moment from "moment";

export const isError = (errors, index, name) => {
    if (errors)
        return get(errors, `tariffs[${index}].${name}`, null) !== null
    return null;
}

export const onCopyValueText = (rowData) => {
    return rowData;
}

export const onPasteValueText = (paste, rowData, rowIndex) => {
    if (paste != null)
        return paste;
}

export const onCopyValueObject= (rowData) => {
    return rowData;
}
export const onCopyValueDate = (rowData) => {
    return rowData ? moment(rowData).format("DD/MM/YYYY") : "";
}
export const onCopyValueDateTracking = (rowData) => {
    if(rowData && rowData.value)
        return moment(rowData.value).format("DD/MM/YYYY")
    if(rowData && !rowData.date)
        return "-"
    return rowData ? moment(rowData.date).format("DD/MM/YYYY") : "";
}

export const onPasteValueDate = (paste, rowData, rowIndex) => {
    const isDate = function (date) {
        return (new Date(date) !== "Invalid Date") && !isNaN(new Date(date));
    }
    if (paste != null) {
        if (isDate(paste) === false)
            return null;

        if (paste.includes(".")) {
            const date = paste.split(".")
            const res = `${date[2]}-${date[1]}-${date[0]}`;
            if (isDate(res))
                return res
            else
                return null
        }
        return paste;
    }
}

//DataGrid Custom components
export const createAddRowsComponent = () => ({addRows}) => {
    const [value, setValue] = useState(1)
    const [rawValue, setRawValue] = useState(String(value))

    return (
        <div className="dsg-add-row d-none">

            <button
                type="button"
                className="dsg-add-row-btn"
                onClick={() => addRows(value)}
            >
                <FormattedMessage id={"common.addRow"}/>
            </button>
            {' '}

        </div>
    )
}